import { ComponentChildren, JSX } from 'preact';
import { cloneElement, isValidElement } from 'preact/compat';
import { T } from '@/ui/tokens';

export function Chip({
  active, onClick, icon, children,
}: {
  active?: boolean;
  onClick?: () => void;
  icon?: JSX.Element;
  children: ComponentChildren;
}) {
  return (
    <button onClick={onClick} style={{
      padding: '8px 14px', borderRadius: 999, border: '1px solid',
      borderColor: active ? T.accent : T.line2,
      background: active ? 'rgba(198,255,61,0.10)' : 'transparent',
      color: active ? T.accent : T.text,
      fontSize: 13, fontWeight: 500, cursor: 'pointer', whiteSpace: 'nowrap',
      display: 'inline-flex', alignItems: 'center', gap: 6, flexShrink: 0,
    }}>
      {icon && isValidElement(icon) ? cloneElement(icon, { s: 14 } as never) : icon}
      {children}
    </button>
  );
}
